import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

interface Props {
    widgetViewMode?: WidgetViewMode;
    isPayloadReadyCallback: () => void;
}

export const useUpdateIfReady = ({ widgetViewMode, isPayloadReadyCallback }: Props) => {
    if (widgetViewMode && WidgetViewModeUtils.isReportView(widgetViewMode)) {
        isPayloadReadyCallback();
    }
};
